import getNestedValue from "./getNestedValue"

export default function hasNestedValue(path, root) {
  let defaultInvoked = false

  getNestedValue(path, root, () => (defaultInvoked = true))

  return !defaultInvoked
}



// WEBPACK FOOTER //
// ../ui-kit/src/lib/nested-values/hasNestedValue.js